import React, { useState } from 'react'
import { com } from '@eidu/web'
import EntityTypeField from '../../pages/permission/path/EntityTypeField'
import ComplexPathField from './ComplexPathField'
import useRenderablePaths from '../misc/useRenderablePaths'
import EntityType = com.eidu.entity.type.EntityType
import EntityTypeId = com.eidu.entity.type.EntityTypeId
import EntityPath = com.eidu.entity.path.EntityPath
import FieldType = com.eidu.entity.field.FieldType

type SemanticLinkTargetFieldsProps = {
  sourceTypeId: EntityTypeId
  entityTypes: readonly EntityType[]
  targetTypes: readonly EntityType[]
  fieldType: FieldType
  selectedPath: EntityPath | undefined
  setSelectedPath: (path: EntityPath | undefined) => void
}

const SemanticLinkTargetFields = ({
  sourceTypeId,
  entityTypes,
  targetTypes,
  fieldType,
  selectedPath,
  setSelectedPath,
}: SemanticLinkTargetFieldsProps) => {
  const [selectedTargetTypeId, setSelectedTargetTypeId] = useState<EntityTypeId>()

  const selectedTargetType = selectedTargetTypeId
    ? targetTypes.find(({ id }) => id.equals(selectedTargetTypeId))
    : undefined
  const targetType = selectedTargetType ?? targetTypes.at(0)
  const renderablePaths = useRenderablePaths(sourceTypeId, targetType, entityTypes)

  return (
    <>
      <EntityTypeField
        entityTypeId={selectedTargetType?.id}
        onChange={(type) => {
          setSelectedTargetTypeId(type.id)
          setSelectedPath(undefined)
        }}
        types={targetTypes}
        label="Target type"
      />
      <ComplexPathField
        entityTypeId={sourceTypeId}
        targetType={targetType}
        selectedPath={selectedPath}
        setSelectedPath={setSelectedPath}
        renderablePaths={renderablePaths}
        fieldType={fieldType}
      />
    </>
  )
}

export default SemanticLinkTargetFields
